import React from "react";
import HomePage from "../pages/Home";
import NotFoundPage from "../pages/NotFoundPage";
import Login from "../pages/Auth/Login";
import Transporters from "../pages/Transporters";
import Parties from "../pages/Parties/Parties";
import PickLists from "../pages/PickLists/PickLists";
import CheckerPanel from "../pages/CheckerPanel/CheckerPanel";
import PendingInvoices from "../pages/PendingInvoices/PendingInvoices";
import PreDispatchReports from "../pages/PreDispatchReports/PreDispatchReports";
import DispatchReports from "../pages/DispatchReports/DispatchReports";
import DispatchReportPrint from "../pages/DispatchReports/Print";
import TransportForm from "../pages/Transporters/Form/Form";
import PartyForm from "../pages/Parties/Form/Form";
import PickListForm from "../pages/PickLists/Form/Form";
import PendingInvoiceForm from "../pages/PendingInvoices/Form/Form";
import DispatchSummary from "../pages/DispatchSummary/DispatchSummary";
import Profile from "../pages/Profile/Profile";
import Cities from "../pages/Cities";
import CityForm from "../pages/Cities/Form/Form";
import Employees from "../pages/Employees";
import EmployeeForm from "../pages/Employees/Form/Form";

const routes = [
  {
    path: "/",
    element: <HomePage />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "Dashboard",
  },
  {
    path: "/parties",
    element: <Parties />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "PartyMaster",
  },
  {
    path: "/parties/add",
    element: <PartyForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "PartyMaster",
  },
  {
    path: "/parties/edit/:id",
    element: <PartyForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "PartyMaster",
  },
  {
    path: "/cities",
    element: <Cities />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "CityMaster",
  },
  {
    path: "/cities/add",
    element: <CityForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "CityMaster",
  },
  {
    path: "/cities/edit/:id",
    element: <CityForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "CityMaster",
  },
  {
    path: "/employees",
    element: <Employees />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "EmployeeMaster",
  },
  {
    path: "/employees/add",
    element: <EmployeeForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "EmployeeMaster",
  },
  {
    path: "/employees/edit/:id",
    element: <EmployeeForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "EmployeeMaster",
  },
  {
    path: "/transporters",
    element: <Transporters />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "TransporterMaster",
  },
  {
    path: "/transporters/add",
    element: <TransportForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "TransporterMaster",
  },
  {
    path: "/transporters/edit/:id",
    element: <TransportForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "TransporterMaster",
  },

  {
    path: "/pick-lists",
    element: <PickLists />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "PickList",
  },
  {
    path: "/pick-lists/add",
    element: <PickListForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "PickList",
  },

  {
    path: "/pick-lists/edit/:id",
    element: <PickListForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "PickList",
  },

  {
    path: "/checker-panel",
    element: <CheckerPanel />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "CheckerPanel",
  },

  {
    path: "/pending-invoices",
    element: <PendingInvoices />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "PendingInvoice",
  },

  {
    path: "/pending-invoices/edit/:id",
    element: <PendingInvoiceForm />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "PendingInvoice",
  },

  {
    path: "/pre-dispatch-report",
    element: <PreDispatchReports />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "PreDispatchReport",
  },
  {
    path: "/dispatch-report",
    element: <DispatchReports />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "DispatchReport",
  },
  {
    path: "/dispatch-report/print/:id",
    element: <DispatchReportPrint />,
    isPrivate: false,
    layoutType: "Blank",
  },
  {
    path: "/login",
    element: <Login />,
    isPrivate: false,
    layoutType: "Blank",
  },
  {
    path: "/home",
    element: <HomePage />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "Dashboard",
  },
  {
    path: "/dispatch-summary",
    element: <DispatchSummary />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "DispatchSummary",
  },
  {
    path: "/profile",
    element: <Profile />,
    isPrivate: true,
    layoutType: "Auth",
    subject: "Profile",
  },
  {
    path: "*",
    element: <NotFoundPage />,
    isPrivate: false,
    layoutType: "Blank",
  },
];

export default routes;
